import React from 'react';
import PropTypes from 'prop-types';

const CloseIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <path
      d="M8.236 7l4.634-4.634a.876.876 0 0 0 0-1.236.876.876 0 0 0-1.236 0L7 5.764 2.366 1.13a.876.876 0 0 0-1.236 0 .876.876 0 0 0 0 1.236L5.764 7 1.13 11.634a.876.876 0 0 0 0 1.236c.34.34.896.34 1.236 0L7 8.236l4.634 4.634c.34.34.896.34 1.236 0a.876.876 0 0 0 0-1.236L8.236 7z"
    />

  </svg>
);

CloseIcon.propTypes = {
  className: PropTypes.string
};

CloseIcon.defaultProps = {
  className: undefined
};

export default CloseIcon;
